import { render, staticRenderFns } from "./LaGovernance.vue?vue&type=template&id=d33d7400&scoped=true"
import script from "./LaGovernance.vue?vue&type=script&lang=js"
export * from "./LaGovernance.vue?vue&type=script&lang=js"
import style0 from "./LaGovernance.vue?vue&type=style&index=0&id=d33d7400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33d7400",
  null
  
)

export default component.exports